module.exports = __webpack_public_path__ + "img/our_mission_image.376f0cce.png";